import React from 'react';

import { makeIconDef } from '../../makeIconDef';

export const AddIconDef = {
  add: makeIconDef('add', {
    regular: () => <path d="M2 12H22M12 2V22" fill="none" stroke="currentColor" strokeWidth="2" />,
    filled: () => <path d="M2 12H22M12 2V22" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />,
  })
}